<!-- file-viewer.component.html -->
<dx-popup
  [dragEnabled]="true"
  [resizeEnabled]="true"
  [(visible)]="popupVisible"
  i18n-title
  title="Document Viewer"
  [height]="popupSizeHeight"
  [width]="popupSizeWidth"
  [showCloseButton]="true"
  [hideOnOutsideClick]="false"
  restoreSize="true"
  (onShowing)="handleOnShowing($event)"
  (onHiding)="handleOnHiding($event)"
>
  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    [options]="toolbarDownloadButtonOptions"
  >
  </dxi-popup-toolbar-item>

  <div *dxTemplate="let data of 'content'">
    <!-- General File View -->
    <div *ngIf="generalVisible" class="fileviewer-general-container">
      <img
        src="assets/images/icons/folder-documents-icon.png"
        alt="Document Icon"
      />
      <span>{{ currentFileItem?.name }}</span>
    </div>

    <!-- Document View -->
    <object
      *ngIf="documentVisible"
      [data]="fileDisplay | safeResourceURL"
      class="fileviewer-document-container"
    >
      <div class="fallback-message">
        Unable to display document.
        <a [href]="fileURL" download>Click to download</a>
      </div>
    </object>

    <!-- Loading State -->
    <div
      *ngIf="!generalVisible && !fileDisplay"
      class="loading-container"
      [innerHTML]="loadingText"
    ></div>

    <!-- Image View -->
    <div *ngIf="imageVisible && fileDisplay" class="fileviewer-image-container">
      <img
        (error)="handleFileError()"
        [src]="fileDisplay | safeResourceURL"
        [alt]="$safeNavigationMigration(currentFileItem?.name)"
      />
    </div>

    <!-- PDF View -->
    <embed
      width="100%"
      height="100%"
      (error)="handleFileError()"
      (load)="handlePDFLoaded()"
      *ngIf="pdfVisible && fileDisplay"
      [src]="fileDisplay | safeResourceURL"
      class="fileviewer-pdf-container"
      scrolling="auto"
    />
  </div>
</dx-popup>
